import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import PlaceholderImage from "images/png/discography-image-placeholder.png";
import Typography from "components/typography";
import { storeIcons } from "constants/storeIcons";

const ReleaseItemMobile = () => {
  return (
    <Container>
      <Body>
        <CoverImage src={PlaceholderImage} alt="Cover-image" />
        <Typography size="xl" weight="medium" color={Colors.white300}>
          The Vibe
        </Typography>
        <Typography color={Colors.grey400} size="s" mb="1.6">
          Vectra, Sammy T Beatz
        </Typography>
        <DetailsHeaderContainer>
          <Typography weight="medium">Total Streams</Typography>
          <Typography color={Colors.grey500}>
            {Number("12675").toLocaleString()}
          </Typography>
        </DetailsHeaderContainer>
        <StreamsContainer>
          <StreamNameItem>
            <StreamIcon>{storeIcons["spotify"]}</StreamIcon>
            <Typography color={Colors.grey400}>Spotity</Typography>
          </StreamNameItem>
          <Typography color={Colors.grey500} ml="auto">
            {Number("3001").toLocaleString()}
          </Typography>
          <StreamNameItem>
            <StreamIcon>{storeIcons["appleMusic"]}</StreamIcon>
            <Typography color={Colors.grey400}>Apple Music</Typography>
          </StreamNameItem>
          <Typography color={Colors.grey500} ml="auto">
            {Number("4017").toLocaleString()}
          </Typography>{" "}
          <StreamNameItem>
            <StreamIcon>{storeIcons["deezer"]}</StreamIcon>
            <Typography color={Colors.grey400}>Deezer</Typography>
          </StreamNameItem>
          <Typography color={Colors.grey500} ml="auto">
            {Number("2600").toLocaleString()}
          </Typography>{" "}
          <StreamNameItem>
            <StreamIcon>{storeIcons["amazonMusic"]}</StreamIcon>
            <Typography color={Colors.grey400}>Amazon</Typography>
          </StreamNameItem>
          <Typography color={Colors.grey500} ml="auto">
            {Number("3001").toLocaleString()}
          </Typography>{" "}
          <StreamNameItem>
            <StreamIcon>{storeIcons["youtubeMusic"]}</StreamIcon>
            <Typography color={Colors.grey400}>Youtube</Typography>
          </StreamNameItem>
          <Typography color={Colors.grey500} ml="auto">
            {Number("3001").toLocaleString()}
          </Typography>
        </StreamsContainer>
      </Body>
    </Container>
  );
};

export default ReleaseItemMobile;

const Container = styled.div`
  display: none;
  width: 100%;

  @media only screen and (max-width: 769px) {
    display: block;
  }
`;

const Body = styled.div`
  width: 100%;
  border-radius: 0.4rem;
  padding: 2.4rem 1.6rem;
  background-color: ${Colors.grey700};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const CoverImage = styled.img`
  width: 20rem;
  height: 20rem;
  margin-bottom: 0.8rem;
`;

const DetailsHeaderContainer = styled.div`
  display: flex;
  margin-bottom: 1.6rem;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const StreamsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: space-between;
  row-gap: 1.2rem;
`;

const StreamNameItem = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;
  width: fit-content;
`;

const StreamIcon = styled.div`
  width: 1.4rem;
  height: 1.4rem;
`;
